import React from 'react';

import component, {classnames} from './component';

export default component('ProfileStats', function({data, className}) {
  return (
    <div className={classnames('ProfileStats', className)}>
      <div className='ProfileStats-Item'>
        <div className='ProfileStats-Label'>Сыграно</div>
        <div className='ProfileStats-Counter'>{data.get('total_games')}</div>
      </div>
      <div className='ProfileStats-Item'>
        <div className='ProfileStats-Label'>Выиграно</div>
        <div className='ProfileStats-Counter'>{data.get('won_games')}</div>
      </div>
      <div className='ProfileStats-Item'>
        <div className='ProfileStats-Label'>Проиграно</div>
        <div className='ProfileStats-Counter'>{data.get('lost_games')}</div>
      </div>
      <div className='ProfileStats-Item'>
        <div className='ProfileStats-Label'>Очки</div>
        <div className='ProfileStats-Counter'>{data.get('score')}</div>
      </div>
    </div>
  );

});



// WEBPACK FOOTER //
// ./src/components/ProfileStats.js